import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HospitalSelectorComponent } from './hospital-selector.component';
import { HospitalsGridModalComponent } from './hospitals-grid-modal/hospitals-grid-modal.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { GridModule } from 'stg-js-ngx-grid';
import {NgSelectModule} from "@ng-select/ng-select";
import { GridRenderersModule } from '../grid-renderers/grid-renderers.module';


@NgModule({
    declarations: [
        HospitalSelectorComponent,
        HospitalsGridModalComponent
    ],
    exports: [
        HospitalSelectorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        GridModule,
        GridRenderersModule,
        NgSelectModule
    ]
})
export class HospitalSelectorModule { }
